<template>
    <div class="container">
      <b-row class="justify-content-center">
        <b-col md="6">
          <div class="clearfix">
            <h1 class="float-left display-3 mr-4"></h1>
            <h4 class="pt-3">Access Denied</h4>
            <p class="text-muted">You have not sufficient permissions for access this page.</p>
          </div>
        </b-col>
      </b-row>
    </div>
</template>

<script>
export default {
  name: 'PageAccessDenied'
}
</script>
